<template>
  <v-card>
    <div class="p-popup-media" :class="{ active: isZoomSlide == true }">
      <div class="p-popup-media_container">
        <div class="p-popup-media_close" @click="hanldeCloseModal">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
          >
            <path
              d="M23.75 8.0125L21.9875 6.25L15 13.2375L8.0125 6.25L6.25 8.0125L13.2375 15L6.25 21.9875L8.0125 23.75L15 16.7625L21.9875 23.75L23.75 21.9875L16.7625 15L23.75 8.0125Z"
              fill="#7d987d"
            ></path>
          </svg>
        </div>
        <div class="p-popup-media_body">
          <h3 class="p-popup-media_title">
            <p>写真</p>
            - <span>Photo</span>
          </h3>
          <div class="p-popup-media_wrap">
            <div
              class="p-popup-media_slide"
              :class="{ active: isZoomSlide == true }"
            >
              <div class="p-popup-media_slide_img">
                <Carousel
                  id="gallery"
                  :itemsToShow="1"
                  v-model="currentSlide"
                  :wrap-around="false"
                  ref="myCarousel"
                  @init="handleInit"
                  :mouseDrag="false"
                >
                  <Slide v-for="(item, index) in dataImage" :key="index">
                    <div class="carousel__item">
                      <img
                        :src="convertImgPathWithEnv(item.path_image)"
                        :alt="item.title"
                        @click="handleZoom"
                      />
                    </div>
                  </Slide>

                  <template #addons="{ slidesCount }">
                    <div class="p-popup-media_slide_navigation">
                      <div class="p-popup-media_slide_navigation_text">
                        <span>{{ currentSlide + 1 }}</span
                        >/<span>{{ totalSlideItem }}</span>
                      </div>
                      <Navigation v-if="slidesCount > 1">
                        <template #next>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="20"
                            @click="handleChangeWidth"
                            viewBox="0 0 14 20"
                            fill="none"
                          >
                            <path
                              d="M13.606 9.2106C13.7308 9.31383 13.8299 9.43665 13.8975 9.57198C13.9651 9.7073 13.9999 9.85245 13.9999 9.99905C13.9999 10.1457 13.9651 10.2908 13.8975 10.4261C13.8299 10.5614 13.7308 10.6843 13.606 10.7875L2.9516 19.6715C2.82779 19.7756 2.68049 19.8582 2.5182 19.9146C2.35591 19.971 2.18184 20 2.00602 20C1.83021 20 1.65614 19.971 1.49384 19.9146C1.33155 19.8582 1.18426 19.7756 1.06045 19.6715C0.93562 19.5683 0.836542 19.4455 0.768929 19.3101C0.701315 19.1748 0.666504 19.0297 0.666504 18.8831C0.666504 18.7365 0.701315 18.5913 0.768929 18.456C0.836542 18.3207 0.93562 18.1978 1.06045 18.0946L10.7826 9.99905L1.06045 1.9035C0.809665 1.69439 0.668777 1.41077 0.668777 1.11504C0.668777 0.819316 0.809665 0.5357 1.06045 0.326589C1.31123 0.117477 1.65136 2.20335e-09 2.00602 0C2.36068 -2.20335e-09 2.70082 0.117477 2.9516 0.326589L13.606 9.2106Z"
                              fill="white"
                            ></path>
                          </svg>
                        </template>
                        <template #prev>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="20"
                            @click="handleChangeWidth"
                            viewBox="0 0 14 20"
                            fill="none"
                          >
                            <path
                              d="M12.9395 18.0946C13.0643 18.1978 13.1634 18.3207 13.231 18.456C13.2986 18.5913 13.3334 18.7365 13.3334 18.8831C13.3334 19.0297 13.2986 19.1748 13.231 19.3101C13.1634 19.4455 13.0643 19.5683 12.9395 19.6715C12.8157 19.7756 12.6684 19.8582 12.5061 19.9146C12.3438 19.971 12.1697 20 11.9939 20C11.8181 20 11.644 19.971 11.4817 19.9146C11.3194 19.8582 11.1721 19.7756 11.0483 19.6715L0.393943 10.7875C0.269116 10.6843 0.170038 10.5614 0.102425 10.4261C0.0348112 10.2908 0 10.1457 0 9.99905C0 9.85245 0.0348112 9.7073 0.102425 9.57198C0.170038 9.43665 0.269116 9.31383 0.393943 9.2106L11.0483 0.326589C11.2991 0.117478 11.6392 0 11.9939 0C12.1695 0 12.3434 0.0288416 12.5056 0.0848778C12.6679 0.140914 12.8153 0.223048 12.9395 0.326589C13.0636 0.430131 13.1621 0.553052 13.2294 0.688336C13.2966 0.823619 13.3311 0.968615 13.3311 1.11504C13.3311 1.26147 13.2966 1.40647 13.2294 1.54175C13.1621 1.67704 13.0636 1.79996 12.9395 1.9035L3.21735 9.99905L12.9395 18.0946Z"
                              fill="white"
                            ></path>
                          </svg>
                        </template>
                      </Navigation>
                    </div>
                  </template>
                </Carousel>
              </div>
              <div
                class="p-popup-media_slide_text"
                v-for="(item, index) in dataImage"
                :key="index"
              >
                <p class="content" v-if="index == currentSlide && item.title">
                  {{ item.title }}
                </p>
                <p
                  class="content"
                  v-if="
                    index === currentSlide &&
                    item.id &&
                    Number.isFinite(item.id)
                  "
                >
                  {{
                    props.inforSpace?.rental_space_facility
                      ?.rental_space_facility_img_note
                  }}
                </p>
              </div>
            </div>
            <div
              class="p-popup-media_right"
              :class="{ active: isZoomSlide == true }"
            >
              <div class="p-popup-media_list" v-if="listImageSpace.length > 0">
                <h6 class="p-popup-media_list_title">会場内</h6>
                <div class="p-popup-media_list_wrap">
                  <div
                    class="p-popup-media_list_item"
                    v-for="(item, index) in listImageSpace"
                    :key="index"
                  >
                    <img
                      class="w-100"
                      :src="convertImgPathWithEnv(item.path_image)"
                      :alt="item.title"
                      @click="handleDisplayImg(item.id)"
                    />
                  </div>
                </div>
              </div>
              <div
                class="p-popup-media_list"
                v-if="newDataImageFacility.length > 0"
              >
                <h6 class="p-popup-media_list_title">図面</h6>
                <div class="p-popup-media_list_wrap">
                  <div
                    class="p-popup-media_list_item"
                    v-for="(itemFacility, index) in dataImageFacility"
                    :key="index"
                  >
                    <img
                      class="w-100"
                      :src="convertImgPathWithEnv(itemFacility.path_image)"
                      :alt="`facility image ${index}`"
                      @click="handleDisplayImg(itemFacility.id)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-img-btn">
            <button v-if="!isZoomSlide" @click="hanldeCloseModal">
              もどる
            </button>
            <button v-if="isZoomSlide" @click="handleBackZoom">
              一覧にもどる
            </button>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script setup>
import { ref, defineEmits, defineProps, computed, onMounted } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import { convertImgPathWithEnv } from "@/client/utils";

const emit = defineEmits(["handleShowModalImg"]);

const hanldeCloseModal = () => {
  emit("handleShowModalImg");
};

const props = defineProps({
  inforSpace: {
    type: String,
  },
  fristImageFacilityId: { type: Number },
});
const listImageSpace = ref(props.inforSpace.image);
const dataImageFacility = ref(
  props.inforSpace?.rental_space_facility?.rental_space_facility_img_urls
);
const newDataImageFacility = computed(() => {
  dataImageFacility.value.forEach((item) => {
    item.path_image = item.url;
  });
  return dataImageFacility.value;
});
const dataImage = computed(() =>
  listImageSpace.value.concat(newDataImageFacility.value)
);
const totalSlideItem = ref(dataImage.value.length);
const currentSlide = ref(0);
const myCarousel = ref(null);
const isZoomSlide = ref(false);
const screenWidth = ref();

const handleZoom = () => {
  isZoomSlide.value = true;
  setTimeout(() => {
    myCarousel.value.updateSlideWidth("auto");
  }, 150);
};

const checkScreenWidth = () => {
  const w = window.screen.width;
  screenWidth.value = w;
};
checkScreenWidth();

window.addEventListener("resize", function () {
  checkScreenWidth();
});

const handleDisplayImg = (id) => {
  const index = dataImage.value.findIndex((image) => image.id === id);
  if (index !== -1) {
    if (screenWidth.value <= 920) {
      setTimeout(() => {
        myCarousel.value.updateSlideWidth("auto");
      }, 150);
      isZoomSlide.value = true;
      currentSlide.value = index;
    } else {
      currentSlide.value = index;
      setTimeout(() => {
        myCarousel.value.updateSlideWidth("auto");
      }, 150);
    }
  } else {
    console.log(`Image with ID "${id}" not found.`);
  }
};

const handleChangeWidth = () => {
  myCarousel.value.updateSlideWidth("auto");
};

const handleBackZoom = () => {
  isZoomSlide.value = false;
  setTimeout(() => {
    myCarousel.value.updateSlideWidth("auto");
  }, 150);
};

onMounted(() => {
  if (props.fristImageFacilityId) {
    setTimeout(() => {
      handleDisplayImg(props.fristImageFacilityId);
      myCarousel.value.updateSlideWidth("auto");
    }, 250);
  }
});
</script>

<style lang="scss" scoped>
@mixin sp {
  // スマートフォン表示
  @media only screen and (max-width: 920px) {
    @content;
  }
}

@mixin tl {
  // タブレット表示
  @media (max-width: 1024px) {
    @content;
  }
}

@mixin tablet {
  // タブレット表示
  @media only screen and (max-width: 1199px) {
    @content;
  }
}

@media screen and (max-width: 600px) {
  .v-dialog > .v-overlay__content {
    margin: 0;
  }
}

.p-popup-media {
  overflow: hidden;
  height: 100%;
  padding: 0 10px;
  @media (max-width: 768px) {
    width: 80vw;
  }

  @media screen and (max-width: 600px) {
    overflow: scroll;
  }

  &_close {
    position: absolute;
    top: 0;
    right: 0;
	z-index: 4;
    cursor: pointer;
  }

  &_title {
    color: #666;
    font-size: 24px;
    font-weight: 400;
    line-height: 18px;
    padding: 20px 0;
    border-bottom: 1px solid #7d987d;
    display: flex;
    align-items: center;
    gap: 10px;

    p {
      color: #7d987d;
      font-size: 24px;
      font-weight: 600;
      line-height: 18px;
    }

    span {
      font-size: 18px;
    }
  }

  &_body {
    height: 100%;
    position: relative;
  }

  &_wrap {
    padding: 20px 10px;
    display: flex;
    gap: 10px;
    height: calc(80vh - 135px);
    overflow-x: hidden;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background: #2c3f50;
    }

    &::-webkit-scrollbar-track {
      background-color: rgba(236, 236, 236, 0.8);
    }

    @include sp {
      flex-direction: column;
      margin: 5px 0;
      padding: 0 10px;
    }
  }

  &_slide {
    flex: 62.04%;
    max-width: 62.04%;
    flex-shrink: 0;

    @include sp {
      flex: 100%;
      max-width: 100%;
      position: absolute;
      opacity: 0;
      visibility: hidden;

      &.active {
        position: relative;
        opacity: 1;
        visibility: visible;
      }
    }

    &.active {
      flex: 100%;
      max-width: 100%;

      .carousel__slide {
        height: 60vh;
        max-height: unset;
      }

      .p-popup-media_slide_text .content {
        max-height: 200px;
      }
    }

    &_navigation {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 36px;
      background: rgba(0, 0, 0, 0.8);
      position: relative;

      &_text {
        span {
          color: #fff;
          font-size: 18px;
          font-weight: 400;
          line-height: 16px;
        }

        color: #fff;
        font-size: 18px;
        font-weight: 400;
        line-height: 16px;
        left: 50%;
        position: absolute;
        transform: translateX(-50%);
      }
    }

    &_text {
      color: #666;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-top: 10px;
      white-space: pre-wrap;

      .content {
        overflow-y: auto;
        max-height: 130px;
        padding-bottom: 10px;

        &::-webkit-scrollbar {
          width: 8px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 6px;
          background: #2c3f50;
        }

        &::-webkit-scrollbar-track {
          background-color: rgba(236, 236, 236, 0.8);
        }
      }
    }
  }

  &_right {
    flex: calc(100% - 62.04% - 10px);
    max-width: calc(100% - 62.04% - 10px);
    overflow-y: auto;
    padding-bottom: 30px;
    transition: 0.3s ease;

    &.active {
      width: 0;
      display: none;
    }

    @include sp {
      max-height: unset;
      flex: 100%;
      max-width: 100%;
    }

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background: #2c3f50;
    }

    &::-webkit-scrollbar-track {
      background-color: rgba(236, 236, 236, 0.8);
    }
  }

  &_list {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }

    &_title {
      display: block;
      width: 100%;
      color: #222;
      font-size: 20px;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: 2px;
      padding: 10px 20px;
      position: relative;
      border-bottom: 1px solid #516f8b;

      &::before {
        content: "";
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        width: 10px;
        height: 20px;
        background: #7d987d;
      }
    }

    &_wrap {
      display: grid;
      grid-template-columns: repeat(5, minmax(0, 1fr));
      gap: 10px;
      padding: 10px 26px 0 0;

      @include tl {
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }

      @include sp {
        padding: 10px 0;
      }
    }

    &_item {
      position: relative;
      padding-top: 100%;
      cursor: pointer;

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        @include sp {
          object-fit: cover;
        }
      }
    }
  }

  &_button {
    button {
      color: #fff;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
      width: 150px;
      padding: 5px 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      background: #97a2ad;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      border: none;
      margin: auto;
      margin-bottom: 10px;
    }
  }

  .carousel__slide {
    max-height: 500px;
    min-width: 100%;
    justify-content: center;
  }

  .carousel__item {
    display: block;
    cursor: pointer;
    height: 100%;

    img {
      height: 100%;
      max-width: 100%;
      object-fit: fill;
    }
  }

  .modal-img-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 10px;

    @media only screen and (max-width: 768px) {
      padding-top: 5px;
    }
    button {
      color: #fff;
      display: flex;
      padding: 5px 45px;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      background: #97a2ad;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      text-align: center;
      font-family: "Poppins", sans-serif;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
    }
  }
}

@include sp {
  .p-popup-media .carousel__item {
    height: 250px;
  }

  .p-popup-media_slide.active .carousel__slide {
    height: 250px;
    max-width: 100%;
  }

  .p-popup-media_slide_text {
    font-size: 13px;
  }

  .p-popup-media .carousel__item img {
    object-fit: fill;
  }
}

@media (max-width: 600px) {
  .p-popup-media .carousel__item {
    height: 150px;
  }

  .p-popup-media_slide.active {
    .carousel__item {
      height: 250px !important;
    }
  }
}

.popup_photo {
  .v-card {
    height: 100% !important;
  }
}
</style>
